import { createBrowserHistory } from 'history';

// history 5 dropped goBack/length and reshaped the listen() callback to
// `({ location, action })`. mobx-state-router 6 still uses the v4 surface
// internally (history.goBack/listen(location => ...)/history.length), so we
// wrap the v5 instance in a thin v4-compat facade. Drop the shim when
// mobx-state-router lifts to history v5.
const v5 = createBrowserHistory();

// v4 normalized push('') / push('?q=1') to a root-relative path. v5 treats
// those as no-ops (no path component → no navigation). mobx-state-router's
// HistoryAdapter pushes routerStateToUrl(state), which is the empty string
// for routes whose pattern is '' (e.g. the dashboard). Without this
// normalization, post-login navigation pushes '' and never leaves /login.
function normalizeTo(to) {
    if (typeof to !== 'string') return to;
    if (to === '' || to[0] === '?' || to[0] === '#') return '/' + to;
    return to;
}

const history = {
    get location() { return v5.location; },
    get action() { return v5.action; },
    get length() { return 0; },
    push: (to, state) => v5.push(normalizeTo(to), state),
    replace: (to, state) => v5.replace(normalizeTo(to), state),
    go: (delta) => v5.go(delta),
    goBack: () => v5.back(),
    goForward: () => v5.forward(),
    createHref: (to) => v5.createHref(normalizeTo(to)),
    listen: (listener) => v5.listen(({ location, action }) => listener(location, action)),
    block: (blocker) => v5.block(blocker),
};

export default history;
